const ar = {
    aftersales:{
        "contactus":"اتصل بنا للحصول على استجابة سريعة",
        "workorder":"قائمة أوامر العمل",
        "createjob":"إنشاء وظيفة",
        "submittinworkorder":"عند تقديم أمر عمل، يرجى تضمين أكبر قدر ممكن من المعلومات المفصلة،مثل لقطات الشاشة للأخطاء،ومعلومات الحساب، وما إلى ذلك، حيث تعد هذه المعلومات مهمة جدًا بالنسبة لنا للتعامل مع المشاكل بسرعة.",
        "workordercontent":"محتوى أمر العمل",
        "subscriptionaccount":"حساب الاشتراك",
        "problemtype":"نوع المشكلة",
        "tobeprocessed":"قيد المعالجة",
        "processed":"تمت المعالجة",
        "revoked":"تم إلغاءه",
        "create":"إنشاء",
        "workorderno":"رقم أمر العمل",
        "product":"المنتج",
        "status":"الحالة",
        "type":"النوع",
        "ticket":"التذكرة",
        "createtime":"وقت الإنشاء",
        "reply":"رد",
        "operate":'تعمل',
        "onlinechat":"الدردشة عبر الإنترنت",
        "resolveworkorder":"سوف نقوم بحل المشكلة في أقرب وقت ممكن بعد تقديم طلب العمل الخاص بك",
        "noworkorder":"لا يوجد أمر العمل",
        "revoke":"إلغاء",
        "content":"محتوى"

    },
    excode:{
        "redemptioncode":"رمز الاسترداد",
        "pleaseredemptioncode":"يرجى إدخال رمز الاسترداد",
        "exchange":"التبديل",
        "notused":"غير مستخدم",
        "used":"مستخدم",
        "expired":"منتهية الصلاحية",
        "status":"الحالة",
        "exchangetime":"تاريخ التبديل",
        "createtime":"وقت الإنشاء",
        "selectactivityarea":"الرجاء تحديد منطقة النشاط",
        "optionaltraintickets":"تذاكر اختيارية",
        "newpurchase":"شراء جديد",
        "renew":"تجديد"
    },
    header:{
        "personaldetails":"معلومات شخصية"
    },
    footer:{
        "contactus":"اتصل بنا",
        "navigation":"شريط القائمة / التنقل",
        "home":"الصفحة الرئيسية",
        "friends":"الأصدقاء",
        "subscribe":"الاشتراك",
        "aftersales":"خدمة ما بعد البيع",
        "help":"المساعدة",
        "termsofuse":"شروط الاستخدام",
        "refundpolicy":"سياسة الاسترداد",
        "privacypolicy":"سياسة الخصوصية",
        "paymentmethod":"طريقة الدفع",
        "language":"اللغة",
        "map":"خريطة الموقع",
        "homescreen":"الشاشة الرئيسية",
        "setpreferences":"اضبط تفضيلاتك",
        "setlanguage":"يرجى ضبط لغتك"
    },
    friends:{
        "promotioninfo":"معلومات الترويج",
        "currentlevel":"المستوى الحالي",
        "content":"يمكنك استخدام روابط الترويج الحصرية ورموز الخصم لمشاركتها مع الآخرين وكسب عمولة. كلما كان المستوى أعلى، زادت حصة العمولة.",
        "rolemembers":"يمكنك دعوة أصدقاء وكلما كان المستوى أعلى، ستحصل على خصومات وجوائز أعلى.",
        "promotionallinks":"روابط الترويج",
        "discountcodes":"رموز الخصم",
        "copy":"نسخ",
        "rebateratio":"نسبة العمولة",
        "discountratio":"نسبة الخصم",
        "lowestdiscountratio":"أدنى خصم",
        "walletsandpoints":"المحافظ والنقاط",
        "applywithdrawal":"بعد تقديم طلب السحب، سنقوم بمراجعتهوالدفع في غضون 3 أيام عمل.",
        "withdraw":"سحب الأموال",
        "record":"سجل السحب",
        "integral":"نقاط",
        "pointsused":"يمكن استخدام النقاط في السحب على الجوائز",
        "orderdetails":"تفاصيل الطلب",
        "orderamount":"مبلغ الطلب",
        "earnings":"الأرباح",
        "withdrawalsrecord":"سجلات السحب",
        "accounts":"حساب",
        "accounttype":"نوع الحساب",
        "withdrawalamount":"مبلغ السحب",
        "cancel":"إلغاء",
        "submit":"إرسال",

        "greaterthan":"يجب أن يكون مبلغ السحب أكبر من 5يجب أن يكون مبلغ السحب أكبر من 5",
        "normal":"طبيعي",
        "invalid":"غير صالح",
        "bankcard":"بطاقة بنكية",
        "promotionlink":"رابط الترويج",
        "discountcode":"رمز الخصم",
        "waitingforapproval":"قيد المراجعة",
        "waitingforpayment":"قيد الدفع",
        "notpass":"لم يتم الموافقة",
        "paid":"تم الدفع",

        "cashwithdrawalid":"رقم السحب",
        "accountsreceivable":"الحسابات المدينة المستحقة",
        "amount":"المبلغ",
        "status":"الحالة",
        "applicationtime":"وقت الطلب",
        "processingresults":"نتيجة المعالجة",

        "orderid":"رقم الطلب",
        "useramount":"مبلغ الشراء",
        "duration":"مدة الشراء",
        "promotiontype":"نوع الترويج",
        "createtime":"وقت الإنشاء",
        "eainings":"الأرباح (بالدولار)",

        "receivingaccount":"حساب الاستلام",
        "nowithdrawableamount":"لا يوجد مبلغ قابل للسحب",
        "copysuccessfully":"تم النسخ بنجاح",
        "copyfailed":"فشلت عملية النسخ",
        "salesvolume":"حجم المبيعات",
        "nodata":"لا توجد بيانات حتى الآن"
    },
    home:{
        'notice':'Click getNfcode to get the solution to Netflix unable to log in',
        'join':'انضم',
        "texttitle":"افتح اشتراكك المشترك بسعر أقل",
        "buynow":"شراء الآن",
        "soldout":"تم بيع الاشتراك",
        "delivery":"تسليم فوري",
        "after":"بعد الدفع، تسليم الفوري بدون انتظار",
        "certificate":"مصادقة SSI",
        "payments":"دفع في بيئة آمنة مصادقة SSI",
        "onlinesupport":"خدمة عملاء عبر الإنترنت على مدار 24 ساعة، 7 أيام في الأسبوع",
        "privatecustomer":"خدمة عملاء فردية عبر الإنترنت على مدار 24 ساعة، 7 أيام في الأسبوع",
        "subscriber":"حقوق المشتركين",
        "subscriptions":"اشتراك مشترك بأسعار منخفضة، مع الأولويةللمشتركين المشتركين من نفس البلد",
        "moneyback":"ضمان استرداد الأموال",
        "refund":"لديك مهلة 1-20 يومًالتقديم طلب استرداد الأموال",
        "parkingspace":"موقف للسيارة",
        "gift":"هدايا",
        "screen":"حساب فرعي",
        "1screen":"حساب فرعي واحد",
        "maxnum":"حساب فرعي",
        "month":"شهر",
        "buytyp":"نوع الشراء",
        "subscription":"اشتراك",
        "voucher":"قسيمة",
        "discountcode":"رمز الخصم",
        "use":"استخدام",
        "paymentmethod":"طريقة الدفع",
        "pleasechoose":"يرجى الاختيار",
        "billingdetails":"تفاصيل الفاتورة",
        "payaddress":"تفاصيل العنوان الكامل للفاتورة",
        "firstname":"الاسم الأخير",
        "lastname":"الاسم الأول",
        "emailaddress":"عنوان البريد الإلكتروني",
        "phone":"رقم الهاتف",
        "country":"البلد",
        "state":"المحافظة",
        "city":"المدينة",
        "address":"عنوان الشارع",
        "housenumber":"رقم الشارع",
        "suiteunit":"شقة، جناح، وحدة إلخ (اختياري)",
        "zipcode":"الرمز البريدي",
        "submit":"تقديم",
        "creditcard":"بطاقة بنكية",
        "cardnumber":"رقم البطاقة",
        "expirydate":"تاريخ انتهاء الصلاحية",
        "nameoncard":"اسم صاحب البطاقة",
        "savethiscard":"حفظ كبطاقة افتراضية",
        "play":"تقديم",
        "emailerror":"عنوان البريد الإلكترونيغير صحيح",
        "payresluttitle":"تم الدفع بنجاح",
        "Pleaseconfirmsuk":"يرجى تأكيد معلومات المنتج",
        "buytips":"تتم مشاركة جميع اشتراكاتنا وبيعها كحسابات فرعية ، يرجى التأكد من فهمك لذلك قبل الشراء.",
        "pleaseenter":"يرجى إدخال",
        "selectamonth":"الرجاء اختيار الشهر",
        "selectthenumber":"الرجاء اختيار عدد الحسابات الفرعية",
        "selectthepurchase":"الرجاء اختيار نوع الشراء",
        "selectthepayment":"الرجاء اختيار طريقة الدفع",
        "discountcodenotempty":"لا يمكن ترك الرمز البريدي فارغًا!",
        "detail1":"<p><i class=\"el-icon-check\"></i><span>خطة متقدمة، $3.69 فيالشهر للشاشة الواحدة</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>خمسة أشخاص يشتركون في حساب واحد</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>يدعم الهواتف المحمولةوأجهزة الكمبيوتر والتلفزيون</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K, HDR, Dolby</span></p>",
        "detail2":"<p><i class=\"el-icon-check\"></i><span>خطة متقدمة، $2.55 فيالشهر للحساب الفرعي</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>جودة صوت عالية الجودة</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>تسليم فوري</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>يدعم الهواتف المحمولةوأجهزة الكمبيوتر والأجهزة اللوحية</span></p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: 110px; top: 77.3906px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail3":"<p><i class=\"el-icon-check\"></i><span>خطة متقدمة، $2.1 في الشهر للحساب الفرعي</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>ستة أشخاص يشتركون في حساب واحد,</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>يدعم الهواتف المحمولةوأجهزة الكمبيوتر والتلفزيون</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>سجل العرض الخاص  </span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>احفظ تفضيلاتك وقوائمك</span></p>",
        "detail5":"<p><i class=\"el-icon-check\"></i><span>خطة متقدمة، $3.88 في الشهر للشاشة الواحدة</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>إرسال رابط الدعوة في الوقت الفعلي</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>حساب اشتراك خاص, احفظ تفضيلاتك وقوائمك</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>ضمان استرداد الأموال</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>المساعدة: قبل الشراء ، تحقق من play.google.com إذا كان بلد حسابك هو ES ، و FR ، و PL ، و IT ، و DE ، و NL ، و GB ، و CA ، و US ، و JP ، و GR ، و CH ، و LT ، و PA ، و SG ، و CZ ، و SE ، PT ، BE ، IL.</span></p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: -51px; top: 143.094px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail7":"<p><i class=\"el-icon-check\"></i><span>تجديد الاشتراك نفسه </span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>حفظ تفضيلاتك والقوائمالخاصة بك</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>توصيل فوري</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>ضمان استرداد الأموال</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>الاشتراك المشترك</span></p>",
        "detail9":"<p><i class=\"el-icon-check\"></i> <span>خطة متقدمة، $3.69 فيالشهر للشاشة الواحدة</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>خمسة أشخاص يشتركون في حساب واحد</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>يدعم الهواتف المحمولةوأجهزة الكمبيوتر والتلفزيون</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K, HDR, Dolby</span></p>",
        "detail10":"<p><i class=\"el-icon-check\"></i><span>خطة متقدمة، $3.88 في الشهر للشاشة الواحدة</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>إرسال رابط الدعوة في الوقت الفعلي</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>حساب اشتراك خاص</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>احفظ تفضيلاتك وقوائمك</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>ضمان استرداد الأموال</span></p>",
        "detail11":
            "<p><i class=\"el-icon-check\"></i><span>حساب اشتراك خاص</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>احفظ تفضيلاتك وقوائمك</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>ضمان استرداد الأموال</span></p>",
        "lowerpricesharelarge":"شارك الاشتراكات المميزة بأسعار أقل على",
        "lowerpricesharesmall":"شارك الاشتراكات المميزة بأسعار أقل على <span class='green-text-2'>AlongShare</span>",
        "highqualitystreaming":"توفير جودة عالية وسعر منخفض لمدة 3 سنوات متتالية",
        "detail":"تحقق من التفاصيل",
        "moreactivities":"الكثير من الأنشطة، والكثير من المكاسب",
        "sharejoinsubscription":"<span class='green-text-2'>مشاركة</span>انضم إلى التعاون",
        "shareyoursubscription":"شارك على طول شارك مع الأصدقاء",
        "availabletime":"مع كود الخصم الحصري",
        "makemoney":"قام شخص آخر بالشراء باستخدام رمز الخصم الخاص بك",
        "widerangesubscription":"يمكنك الحصول على حسومات الطلب المقابلة",
        "threestepsshare":"يمكن الاطلاع على تفاصيل أمر الترويج في لوحة العمولة",
        "joinsubscription":"انضم إلى التعاون",
        "saveupsubscriptionfees":"النشر الذاتي للمنشورات/مقاطع الفيديو الترويجية على Naver/YouTube/Telegram",
        "securepayment":"يتضمن العرض الترويجي رمز الخصم الخاص به",
        "manualreview":"بعد الترقية، يمكنك بسهولة التحقق من حالة الطلب على صفحة \"추천 할인\"",
        "oneclickjoin":"يمكنك سحب الأموال عندما يتراكم في محفظتك 30 دولارًا.",
        "whyusealongshare":"لماذا <span class='green-text-2'> يتزايد عدد الأشخاص</span> الذين يستخدمون <span class='green-text-2'> Alongshare</span>",
        "position":"{0} بت",
        "selectdiscount":"حدد الخصم",
        "notstoreinfo":"لا يقوم AlongShare بتخزين معلومات بطاقتك. يتم تأمين جميع المعاملات ومعالجتها والترخيص بها من قبل مزود دفع خارجي",
        "alumpsum":"الدفع لمرة واحدة",
        "details":"تفاصيل",
        "subtotal":"المجموع الفرعي",
        "promotioncodescoupons":"الرموز الترويجية والكوبونات",
        "paymentfee":"رسوم الدفع",
        "total":"المجموع",
        "nowastediscount":"لا تضيعوا هذا الخصم!",
        "hoursjoin":"تم الانضمام منذ {hours} ساعة",
        "minutesjoin":"تم الانضمام منذ {minutes} دقيقة"
    },
    login:{
        "welcomelogin":"مرحبًا بك في تسجيل الدخول",
        "login":"تسجيل الدخول",
        "updatepwd":"تغيير كلمة المرور",
        "reg":"تسجيل حساب جديد",
        "agreement":"يرجى التأكيد بأنك قرأت ووافقت على شروطنا",
        "quicklogin":"تسجيل الدخول السريع",
        "sendcode":"إرسال رمز التحقق",
        "register":"التسجيل",
        "changepassword":"تغيير كلمة المرور",
        "verificationcode":"رمز التحقق",
        "name":"الاسم",
        "password":"كلمة المرور",
        "agapassword":"أعد إدخال كلمة المرور",
        "modify":"تغيير",
        "validatepswlen":"كلمة السر يجب أن تحتوي على أي حرف ، رقم ، حرف خاص",
        "checkagreement":"يرجى مراجعة الاتفاقية",
        "passwordinconsistency":"كلمتا المرور المدخلتينغير متطابقتين",
        "passwordagain":"يرجى إعادة إدخال كلمة المرور مرة أخرى",
        "verificationsend":"تم إرسال رمز التحقق، يرجى التحقق",
        "useemail":"أو استخدم بريدك الإلكتروني",
        "agree":"من خلال الاستمرار، فإنك توافق على لدينا",
        "and":"و",
        "andconfirm":"والتأكيد",
        "readour":"لقد قرأت لدينا",
        "forgotpassword":"ننسى كلمة المرور",
        "codelogin":"قم بتسجيل الدخول باستخدام رمز التحقق",
        "verifyemail":"التحقق من البريد الإلكتروني",
        "sendcodeemail":"سنرسل رمز التحقق عبر البريد الإلكتروني لإدخال تسجيل إكمال التحقق {email}.",
        "continue":"يكمل",
        "resend":"إعادة الإرسال",
        "noreceivecode":"لا تستطيع قبول رمز التحقق؟",
        "passwordlogin":"تسجيل الدخول بكلمة المرور",
        "setpassword":"تعيين كلمة المرور",
        "confirmpassword":"تأكيد كلمة المرور"
    },
    luckdraw:{
        "lotteryticket":"جائزة",
        "integral":"النقاط",
        "welcome":"هذههي صفحتنا للفعاليات ، انقر على البطاقة للحصول على فرصة للفوز بجوائز فورية،\n" ,
        "none":"تشملالجوائز مجموعة متنوعة من حزم الحسابات المجانية،\n",
        "redemptioncode":"كوبونات الخصم والخصومات الأخرى، نشكركم على دعمكم وثقتكم",
        "copy":"نسخ",
        "prizelist":"قائمة الجوائز",
        "notused":"تم استخدامها",
        "used":"استخدام",
        "expired":"منتهية الصلاحية",

        "prizeno":"رقم الجائزة",
        "contents":"محتوى الجائزة",
        "exchangedate":"تاريخ الاستبدال/تاريخ الاستخدام",
        "createtime":"وقت الإنشاء",
        "exchange":"استبدال",
        "insufficientpoints":"النقاط غير كافية",
        "consumepoints":"هذا الإجراء سيستهلك10 نقاط. هل ترغب في المتابعة؟",
        "tips":"اقتراح",
        "comfirm":"تأكيد",
        "cancel":"إلغاء",
        "failtowin":"لم يتم الفوز",
        "congratulations":"تهانينا، حصلت على",
        "copysucceeded":"تم النسخ بنجاح",
        "copyfailed":"فشلت عملية النسخ",

    },
    subscribe:{
        "clickto":"Click to get link.",
        "Resend":"Have you already sent a new code back? Get it again",
        "getverificationlink":" Get login verification link",
        "getlinktips":"If you have not been asked to fill in the verification code,please ignorethis feature.",
        "renewnow":"تجديد الاشتراك فورًا",
        "subscription":"تجديد الاشتراك نفسه",
        "independent":"جودة عالية بدقة4K+HDR، سجل مشاهدة مستقل",
        "guarantee":"ضمان استرداد الأموال",
        "timeleft":"الوقت المتبقي",
        "openingtime":"تاريخ بدء الحساب",
        "endtime":"تاريخ الانتهاء",
        "account":"اسم المستخدم",
        "password":"كلمة المرور",
        "profile":"الملفات",
        "pleaseuse":"يرجى استخدام",
        "subaccount":"الحساب الفرعي",
        "myprofile":"تم استغلال معلوماتيالشخصية بواسطة شخص ما!",
        "renew":"تجديد الاشتراك",
        "aftersales":"خدمة ما بعد البيع",

        "yourownsub":"1.يرجى استخدام حسابك الفرعي وفقًا للرقم التسلسلي.",
        "delete":"2.يرجى عدم تعديل/حذف حسابات الفرعية الأخرى.",
        "modifysubscription":"3.يرجى عدم تعديل معلومات الاشتراك ذات الصلة.",
        "reminder":"ملاحظة: في حالة وجود أي مشكلة، يرجى الاتصال بخدمة العملاء في أقرب وقت ممكن. عند شراء الاشتراك عبرAlongshare، ستستمتع بخدمة العملاءVIP ولا يلزمك تغيير رقم الحساب عند تجديد الاشتراك.",

        "youtubeloginemail":"يرجى إدخال عنوان بريدك الإلكتروني المستخدمفي تسجيل الدخول إلى يوتيوب. يُرجى التأكد من استخدام عنوان البريد الإلكتروني الخاص بتسجيل الدخول الخاص بك للانضمام إلى المجموعة العائلية، وإلا سيتم طردك من العائلة. إذا كنت بحاجة إلى مساعدة، يرجى الاتصال بخدمة عملاء Alongshare عبر البريد الإلكتروني." ,
        "aftersalesservice":"خدمة ما بعد البيع",
        "support":"صفحة الدعم",
        "submit":"تقديم",

        "buyit":"لا يوجد اشتراك حاليًا ، يرجى الشراء بسرعة",
        "paymentsucceeded":"تم الدفع بنجاح",
        "month":"الرجاء تحديد شهر",
        "number":"الرجاء تحديد عدد الحسابات الفرعية",
        "purchase":"يرجى اختيار نوع الشراء",
        "payment":"يرجى اختيار طريقة الدفع",
        "name":"يرجى إدخال اسمك على البطاقة",
        "card":"يرجى إدخال رقم البطاقة",
        "cvv":"يرجى إدخال CVV",
        "expirydate":"يرجى إدخال تاريخ الانتهاء",
        "processing":"تم تقديم الطلب. يرجى التحقق من حالة المعالجة في أمر العمل.",
        "cannotempty":"رمز الخصم لا يمكن أن يكون فارغًا!",
        "originalpassword":"لن يتم استخدام كلمة المرور الأصلية لهذه العملية بعد الآن ، هل تريد المتابعة؟",
        "passwordmeets":"يجب أن تتضمن كلمة المرور حروفًا كبيرة وحروفًا صغيرة وأرقامًا ورموزًا خاصة، حيث يتم اختيار أي تركيبة من ثلاثة منها على الأقل، ويجب أن يكون طولها بين 8 و 16 حرفًا!"
    },
    userinfo:{
        "signout":"تسجيل الخروج",
        "nickname":"الاسم المستعار",
        "avatar":"الصورة الشخصية",
        "uploadavatar":"يرجى تحميل الصورة الشخصية",
        "logout":"هل أنت متأكد أنك تريد تسجيل الخروج؟",
        "onlyjpgpng":"يمكن أن تكون الصور التي تم تحميلها بتنسيق JPG | تنسيق png",
        "cannotexceed":"لا يمكن أن يتجاوز حجم الصورة التي تم تحميلها 5 ميغا بايت!",
        "exitalongshare":"هل ترغب بالخروج على طول المشاركة؟",
        "personaldata":"البيانات الشخصية",
        "clickimage":"انقر على الصورة لتحريرها",
        "edit":"يحرر",
        "alongshareloginemail":"على طولمشاركة البريد الإلكتروني لتسجيل الدخول",
        "save":"يحفظ",
        "resetpassword":"إعادة تعيين كلمة المرور",
        "editpassword":"تحرير كلمة المرور",
        "passwordmust":"يجب أن يكون لديك كلمة المرور الخاصة بك",
        "anycharacter":"أي أحرف وأرقام وأحرف خاصة",
        "twosamepasswords":"كلمتا المرور اللتين أدخلتهما متماثلتان",
        "currentpassword":"كلمة المرور الحالية",
        "newpassword":"كلمة المرور الجديدة",
        "confirmpassword":"تأكيد كلمة المرور",
        "updatepassword":"تحديث كلمة المرور"
    },
    wish:{
        "wish":"تمنى أمنية",
        "help":"سيقوم AlongShare بتحديد بعض الأماني لتحقيقها",
        "christmas":"سيتم تحقيقها عند حلول عيد الميلاد،قم بترك أمنيتك",
        "submit":"تقديم",
        "mywish":"أمنيتي"
    },
    map:{
        "home":"الصفحة الرئيسية",
        "userinfo":"معلومات المستخدم",
        "login":"تسجيل الدخول",
        "withfriends":"معلومات العمولة",
        "subscribe":"الاشتراك",
        "aftersales":"خدمة ما بعد البيع",
        "luckdraw":"السحب على الجوائز",
        "wish":"تمنى أمنية",
        "helpcenter":"مركز المساعدة",
        "tradingstamps":"صفحة الاستبدال",
        "affiliateprogram":"البرنامج التابع",
        "order":"طلب"
    },
    order:{
        "whetherpayment":"سواء لدفع",
        "yes":"نعم",
        "no":"لا"
    }
}

export default ar
